import { Quote, QuoteAddress, QuoteItem } from '../types/quote';
import {
  mockBondsCarrier,
  mockCouriersPleaseCarrier,
  mockEparcelCarrier,
  mockHubbedCarrier,
  mockTNTCarrier,
  mockSingPostCarrier,
  mockTeleportCarrier,
  mockNinjaVanCarrier,
} from './carrier';

const mockQuoteAddressFromSG: QuoteAddress = {
  address: 'Frasers Tower #02-04',
  suburb: 'Singapore',
  state_code: 'SG',
  postcode: '069547',
  country_code: 'SG',
  po_box_or_locker: true,
};

const mockQuoteAddressFromMY: QuoteAddress = {
  address: 'Petronas Twin Tower, Lower Ground (Concourse) Level',
  suburb: 'Kuala Lumpur City Centre',
  state_code: 'KL',
  postcode: '50088',
  country_code: 'MY',
  po_box_or_locker: true,
};

const mockQuoteAddressFromHK: QuoteAddress = {
  address: 'Shop 12A & 12B, Level 1 MTR Hong Kong Station',
  suburb: 'Central',
  state_code: 'HK',
  postcode: '0000',
  country_code: 'HK',
  po_box_or_locker: true,
};

const mockQuoteAddressFrom: QuoteAddress = {
  address: '210 clarence street',
  suburb: 'Sydney',
  state_code: 'NSW',
  postcode: '2000',
  country_code: 'AU',
  po_box_or_locker: true,
};

export const mockQuoteAddressToSG: QuoteAddress = {
  address: "27 Prince George's Park",
  suburb: 'Singapore',
  state_code: 'SG',
  postcode: '118425',
  country_code: 'SG',
  po_box_or_locker: false,
};

const mockQuoteAddressToMY: QuoteAddress = {
  address: '10, Jalan Kampung Pandan',
  suburb: 'Kelab Golf di Raja Selangor',
  state_code: 'KL',
  postcode: '55000',
  country_code: 'MY',
  po_box_or_locker: true,
};

const mockQuoteAddressToHK: QuoteAddress = {
  address: '9-11 Fuk Wing St',
  suburb: 'Sham Shui Po',
  state_code: 'HK',
  postcode: '0000',
  country_code: 'HK',
  po_box_or_locker: true,
};

const mockQuoteAddressFromID: QuoteAddress = {
  address: 'Gowork Millenium Centennial Center, Level 38',
  suburb: 'Jenderal Sudirman',
  postcode: '12920',
  state_code: 'DKI',
  country_code: 'ID',
  po_box_or_locker: true,
};

const mockQuoteAddressToID: QuoteAddress = {
  address: '12 Pelangi Raya',
  suburb: 'Kelapa Gading',
  postcode: '14240',
  state_code: 'DKI',
  country_code: 'ID',
  po_box_or_locker: true,
};

const mockQuoteAddressFromPH: QuoteAddress = {
  address: 'HXVC+M5V',
  suburb: 'Intramuros',
  postcode: '1002',
  state_code: 'NCR',
  country_code: 'PH',
  po_box_or_locker: true,
};

const mockQuoteAddressToPH: QuoteAddress = {
  address: '551 F Jhocson St',
  suburb: 'Sampaloc',
  postcode: '1008',
  state_code: 'NCR',
  country_code: 'PH',
  po_box_or_locker: true,
};

export const mockQuoteAddressTo: QuoteAddress = {
  address: '6 Foy Street',
  suburb: 'Casino',
  state_code: 'nsw',
  postcode: '2470',
  country_code: 'au',
  po_box_or_locker: false,
};

const mockQuoteItem: QuoteItem = {
  weight_g: 1000,
  width_cm: 1,
  depth_cm: 1,
  length_cm: 1,
};

const recommendations = (countryCode: string = 'AU') => {
  switch (countryCode) {
    case 'SG':
      return [mockTeleportCarrier];
    case 'MY':
      return [mockTeleportCarrier];
    case 'HK':
      return [mockTeleportCarrier];
    case 'PH':
      return [mockNinjaVanCarrier];
    case 'ID':
      return [mockNinjaVanCarrier];
    default:
      return [mockEparcelCarrier, mockCouriersPleaseCarrier, mockHubbedCarrier];
  }
};

const addresses = (countryCode: string = 'AU') => {
  switch (countryCode) {
    case 'SG':
      return {
        to: mockQuoteAddressToSG,
        from: mockQuoteAddressFromSG,
      };
    case 'MY':
      return {
        to: mockQuoteAddressToMY,
        from: mockQuoteAddressFromMY,
      };
    case 'HK':
      return {
        to: mockQuoteAddressToHK,
        from: mockQuoteAddressFromHK,
      };
    case 'PH':
      return {
        to: mockQuoteAddressToPH,
        from: mockQuoteAddressFromPH,
      };
    case 'ID':
      return {
        to: mockQuoteAddressToID,
        from: mockQuoteAddressFromID,
      };
    default:
      return {
        to: mockQuoteAddressTo,
        from: mockQuoteAddressFrom,
      };
  }
};

export const mockQuote = (countryCode: string = 'AU'): Quote => ({
  quotes: {
    recommendations: recommendations(countryCode),
    recommended_timeslots: [],
    failures: [mockBondsCarrier],
  },
  merchant_identifier: 'shippit-store',
  service_levels: ['standard', 'express'],
  delivery_date: '',
  delivery_window: '',
  authority_to_leave: true,
  dutiable_amount: '0.0',
  dangerous_goods: false,
  items: [mockQuoteItem],
  ...addresses(countryCode),
});

export const mockEparcelQuote = {
  ...mockQuote(),
  quotes: {
    ...mockQuote().quotes,
    recommendations: [mockEparcelCarrier],
  },
};

export const mockPickUpQuote = {
  ...mockQuote(),
  quotes: {
    ...mockQuote().quotes,
    recommendations: [mockTNTCarrier],
  },
};

export const mockHubbedQuote = {
  ...mockQuote(),
  quotes: {
    ...mockQuote().quotes,
    recommendations: [mockHubbedCarrier],
  },
};

export const mockSingPostQuote = {
  ...mockQuote('SG'),
  quotes: {
    ...mockQuote('SG').quotes,
    recommendations: [mockSingPostCarrier],
  },
};

export const mockTeleportQuote = {
  ...mockQuote('SG'),
  quotes: {
    ...mockQuote('SG').quotes,
    recommendations: [mockTeleportCarrier],
  },
};
